import * as React from 'react';
import { Text, TextTypography } from '../Text';
import { st, classes } from './DropdownOption.st.css';
import { DropdownOptionTextOverflow } from './types';
export var DropdownOption = function (props) {
    var value = props.value, id = props.id, isSelectable = props.isSelectable, subtitle = props.subtitle, icon = props.icon, isSectionTitle = props.isSectionTitle, className = props.className, unavailable = props.unavailable, indentIcon = props.indentIcon, _a = props.textOverflow, textOverflow = _a === void 0 ? DropdownOptionTextOverflow.ellipsis : _a;
    return (React.createElement("div", { key: id, className: st(classes.root, {
            withIcon: !!icon,
            sectionTitle: isSectionTitle,
            selectable: isSelectable,
            unavailable: !!unavailable,
            indentIcon: !!indentIcon,
            textOverflow: textOverflow,
        }, className) },
        icon && React.createElement("div", { className: classes.icon }, icon),
        React.createElement("div", { className: classes.contentWrapper },
            React.createElement(Text, { className: classes.title, typography: TextTypography.runningText }, value),
            subtitle && (React.createElement(Text, { className: classes.subtitle, typography: TextTypography.runningText }, subtitle)))));
};
//# sourceMappingURL=DropdownOption.js.map